<a
  id="dashboard-your-request-section"
  [routerLink]="ECONOMIC_STUDY_NAME"
  title="Datos personales y económicos"
  class="dashboard-card section-card"
  [ngClass]="{ disabled: status < minStatus.saveData || isRejected }"
>
  <div class="dashboard-card__header">
    <h3 class="h-title">{{ 'your_request_section_title' | translate }}</h3>
  </div>
  <div class="dashboard-card__body">
    <span class="ic ic-mortage"></span>
    @if (!httpError) {
      <div>
        @if (holder1 && !holder2) {
          <h4 class="card-title">
            {{ 'your_request_section_msg_one_holder' | translate: { holder: holder1 | capitalizeFirst } }}
          </h4>
        }

        @if (holder1 && holder2) {
          <h4 class="card-title">
            {{
              'your_request_section_msg_two_holders'
                | translate: { holder1: holder1 | capitalizeFirst, holder2: holder2 | capitalizeFirst }
            }}
          </h4>
        }

        @if (!holder1 && !holder2) {
          <h4 class="card-title">¡Accede para continuar con tu hipoteca!</h4>
        }
        <!-- <p class="card-text">{{requestData?.summary}}</p> -->

        @if (
          status < minStatus.attachDocumentation &&
          status != minStatus.refuseSecondHolder &&
          status != minStatus.waitingAceptedSecondHolder
        ) {
          <div class="btn btn-02">
            {{ 'btn_continue_here' | translate }}
          </div>
        }
      </div>
    }

    @if (httpError) {
      <p class="has-error">{{ 'your_request_section_msg_error' | translate }}</p>
    }
  </div>

  @if (status > 0 && !httpError) {
    <div class="dashboard-card__footer progress-container">
      <h4 class="pd-b-10">{{ 'your_request_section_completed_data' | translate }}</h4>
      <span class="doc-percent">{{ requestData?.percentage | number: '1.0-0' }} %</span>
      <div class="doc-progress"></div>
      <div class="progress-done" [style.width.%]="requestData?.percentage"></div>
    </div>
  }
</a>
